import { Component, OnInit, signal } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { EndLoopComponent } from '../end-loop/end-loop.component';
import { ScanTaskGroupFormsComponent } from '../scan-task-group-forms/scan-task-group-forms.component';

@Component({
  standalone: false,
  selector: 'kt-make-loop-scan',
  templateUrl: './make-loop-scan.component.html',
  styleUrls: ['./make-loop-scan.component.scss'],
})
export class MakeLoopScanComponent extends ModalBaseClass implements OnInit {
  shiftInfo = null;
  loopSequences = [];
  viewMode = false;
  loopDetail = null;
  showNoOfScan = true;
  constructor(public activeModal: NgbActiveModal, private ngbModal: NgbModal, private schedulestoreService: ScheduleStoreService) {
    super(ngbModal);
  }
  buttonConfig = BUTTON_CONFIG;
  timesheetLoop = null;
  actualLoop = null;
  loading = signal(false);
  user_id = 0;

  areaClickHandler(area, loop) {
    const compRef = this.openPopUp(ScanTaskGroupFormsComponent, { shiftInfo: this.shiftInfo, areaId: area.area_id, isLoopScan: true, loopInfo: loop, user_id: this.user_id }, { centered: true, size: 'lg', backdrop: 'static' });
    compRef.result.then(res => {
      if (res.reload) {
        this.activeModal.close({ reload: true });
      }
    });
  }

  ngOnInit() {
    if (this.viewMode) {
      // console.log(this.loopDetail);
      this.dispatchLoopDetail();
    }
    if (this.shiftInfo && this.shiftInfo.timesheet && this.shiftInfo.timesheet.active_loop && this.shiftInfo.timesheet.active_loop.loop) {
      this.loopSequences = this.shiftInfo.timesheet.active_loop.loop.loop_sequence;
    }
    if (this.shiftInfo &&  this.shiftInfo.timesheet_loop) {
      this.timesheetLoop = this.shiftInfo.timesheet_loop;
    }
    this.loopSequences.forEach((seq, index: number) => {
      if (index) {
        seq.expectedStartAt = moment.tz(this.loopSequences[index - 1].expectedStartAt, this.shiftInfo.location.location_fk_timezone_name).add(seq.loop_sequence_interval, 'minute');
      }  else {
        seq.expectedStartAt = moment.tz(this.timesheetLoop.timesheet_log_created_at, this.shiftInfo.location.location_fk_timezone_name).add(seq.loop_sequence_interval, 'minute');
      }
    });
  }

  getLoopDetailPayload() {
    return {
      type: this.loopDetail.shift_loop_id ? TimesheetType.SHIFT : TimesheetType.TIMESHEET,
      shift_loop_id: this.loopDetail.shift_loop_id,
      loop_id: this.loopDetail.loop_id,
      timesheet_log_id: this.actualLoop ? this.actualLoop.timesheet_log_id : 0,
    };
  }

  fillLoopDetail(data) {
    this.loading.set(false);
    if (data.success) {
      this.loopSequences = data.data.data.loop.loop.loop_sequence;
      this.actualLoop = data.data.data.loop.actual_loop;
      this.loopDetail = data.data.data.loop.loop;
    }
  }

  endLoopHandler() {
    const compRef = this.openPopUp(EndLoopComponent, { shiftDetails: this.shiftInfo }, { centered: true, size: 'md', backdrop: 'static' });
    compRef.result.then(res => res.reload ? this.activeModal.close({ reload: true }) : null);
  }

  dispatchLoopDetail() {
    this.loading.set(true);
    this.schedulestoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_SHIFT_LOOP_DETAIL,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: this.getLoopDetailPayload(),
      callback: this.fillLoopDetail.bind(this),
    });
  }

}
